import { render, staticRenderFns } from "./VerifyList2.vue?vue&type=template&id=284e409e&scoped=true&"
import script from "./VerifyList2.vue?vue&type=script&lang=js&"
export * from "./VerifyList2.vue?vue&type=script&lang=js&"
import style0 from "./VerifyList2.vue?vue&type=style&index=0&id=284e409e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284e409e",
  null
  
)

export default component.exports